// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__MYez7","inner":"Footer_inner__3xuSj"};